import { CardElement } from "@stripe/react-stripe-js";

import { Button, classNames } from "@alpacahq/ui/old";

import type { BillingCard } from "~/v2/api/rest/billing";

interface StripeCardProps {
  isEditing: boolean;
  onEditClicked: () => void;
  isUpdateLoading: boolean;
  isUpdateDisabled: boolean;
  onUpdateClicked: () => void;
  onChange: () => void;
  errorMessage: string | null;
  card: BillingCard | undefined;
}

export const StripeCard = ({
  isEditing,
  onEditClicked,
  isUpdateLoading,
  isUpdateDisabled,
  onUpdateClicked,
  onChange,
  errorMessage,
  card,
}: StripeCardProps) => (
  <section className="flex flex-col gap-3 rounded border border-gray-300 bg-white p-3">
    <h3 className="m-0 p-0 text-left font-semibold text-base text-gray-800">
      Credit card or debit card
    </h3>
    <p className="m-0 p-0 text-gray-600 text-sm">
      To replace this payment method, enter your new credit or debit card below.
    </p>

    <div
      className={classNames(
        "rounded p-1.5",
        isEditing
          ? "border border-gray-400"
          : "grid grid-cols-[1fr_auto] items-center gap-2",
      )}
    >
      {isEditing ? (
        <CardElement
          onChange={onChange}
          options={{
            style: {
              base: {
                fontSize: "16px",
                fontWeight: "500",
              },
            },
          }}
        />
      ) : (
        <p
          className={classNames(
            "m-0 p-0 font-medium text-gray-600 text-sm",
            card && "inline-flex items-center gap-2",
          )}
        >
          {card ? (
            <>
              <span>{card.brand}</span>
              <span className="font-mono">**** **** **** {card.last_4}</span>
            </>
          ) : (
            "No card on file"
          )}
        </p>
      )}

      {!isEditing && (
        <Button
          variant="v2/filled"
          size="v2/small"
          className="shrink-0"
          onClick={onEditClicked}
        >
          Edit Payment
        </Button>
      )}
    </div>

    {isEditing && (
      <Button
        variant="v2/filled"
        size="v2/small"
        className="w-fit"
        onClick={onUpdateClicked}
        disabled={isUpdateDisabled}
        loading={isUpdateLoading}
      >
        Save Payment
      </Button>
    )}

    {errorMessage && (
      <p className="m-0 p-0 text-red-500 text-sm">{errorMessage}</p>
    )}
  </section>
);
